// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export let environment = {
  version: '1.17-t',
  production: true,
  apiUrl: 'https://api-app-server.stage.zeitlager.city', // server
  apiKey: 'hjkl24jb5bm7g97jk4h4',
  localhost: true,

  // JUST FOR IMAGE UPLOAD
  apiUrlLive: 'https://api-shop.stage.zeitlager.city', // content
  apiUrlTest: 'https://backend-cronjob.stage.zeitlager.city', // cron/mails

  configId: '',
  configCompany: '', // for app push messages

  payment: {
    paypalLive: {
      clientId: '',
    },
    paypal: {
      live: false,
      clientId: '',
    },
    stripe: {
      live: 'pk_live_...', // ZL live
      test: 'pk_test_...', // die app test
    }
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
